import React from 'react'
import { makeStyles } from '@material-ui/core'
import ArrowBackIosOutlinedIcon from '@material-ui/icons/ArrowBackIosOutlined'
import GlueButton from '../glueos-components/glue-button'
import { useHistory } from 'react-router-dom'

const useStyles = makeStyles(theme => ({
  root: theme.custom.loginPageTemplate.root,

  mainContent: {
    padding: theme.spacing('xl'),
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center'
  },

  logo: {
    margin: theme.spacing('xs'),
    width: '320px',
    height: '96px'
  },

  loginBox: theme.custom.loginPageTemplate.loginBox,

  leftSideContent: theme.custom.loginPageTemplate.leftSideContent,

  rightSideContent: theme.custom.loginPageTemplate.rightSideContent,

  bottomContent: theme.custom.loginPageTemplate.bottomContent,

  backBtn: {
    position: 'absolute'
  }
}), { name: 'MuiGlueLoginPageTemplate' })

const LoginPageTemplate = (props) => {
  const classes = useStyles()
  const history = useHistory()

  return (
    <div className={classes.root}>
      {props.canGoBack && (
        <div className={classes.backBtn}>
          <GlueButton variant='icon' color='stealth' onPointerDown={history.goBack}>
            <ArrowBackIosOutlinedIcon />
          </GlueButton>
        </div>
      )}
      <div className={classes.mainContent}>
        {!props.hideLogo && <img src='https://glue-public-static-resources.s3-eu-west-1.amazonaws.com/web-images/GlueLogo_96.png' alt='' className={classes.logo} /> }
        <div className={classes.loginBox}>
          <div className={classes.leftSideContent}>
            {props.leftSideContent}
          </div>
          <div className={classes.rightSideContent}>
            {props.rightSideContent}
          </div>
        </div>
      </div>
      <div className={classes.bottomContent}>
        {props.bottomContent}
      </div>
    </div>
  )
}

export default LoginPageTemplate
